import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetUserPermissions = {
  getUserPermissions: { data: null, loading: false, error: null },
};

export const getUserPermissions = createAsyncThunk('user/getUserPermissions', async (userId, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/users/${userId}/permissions`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetUserPermissions = {
  [getUserPermissions.pending]: (state) => {
    state.getUserPermissions.loading = true;
    state.getUserPermissions.error = null;
  },
  [getUserPermissions.fulfilled]: (state, action) => {
    state.getUserPermissions.loading = false;
    state.getUserPermissions.data = action.payload;
    state.getUserPermissions.error = null;
  },
  [getUserPermissions.rejected]: (state, action) => {
    state.getUserPermissions.loading = false;
    state.getUserPermissions.error = action.payload;
  },
};
